// Compare month keys, not elapsed days. This also expires badges on saved graph contexts.
export function hasRecentEmploymentSupport(properties: Record<string, unknown> | null | undefined, asOf = new Date()): boolean {
  const month = properties?.employment_support_last_positive_month;
  if (typeof month !== 'string' || !/^\d{4}-(0[1-9]|1[0-2])-01$/.test(month)) return false;
  const current = asOf.getFullYear() * 12 + asOf.getMonth();
  const observed = Number(month.slice(0, 4)) * 12 + Number(month.slice(5, 7)) - 1;
  return observed >= current - 12 && observed < current;
}
